module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popularize"
  }, [_c('img', {
    staticClass: "top-banner",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/others/banner3.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "separate-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "sections"
  }, [_c('div', {
    staticClass: "section-wrapper",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("- 男生小说 -")]), _vm._v(" "), _c('div', {
    staticClass: "works-wrapper",
    staticStyle: {
      "padding": "20px 50px 70px 20px",
      "border-right": "1px solid #d9d9d9"
    }
  }, [_c('div', {
    staticClass: "work"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day3/酒局.jpg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("酒局")])]), _vm._v(" "), _c('div', {
    staticClass: "work"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day3/采珠勿惊龙.jpg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("采珠勿惊龙")])]), _vm._v(" "), _c('div', {
    staticClass: "work"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day3/守夜者.jpg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("守夜者")])]), _vm._v(" "), _c('div', {
    staticClass: "work"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day3/天影.jpg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("天影")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-wrapper",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("- 经典出版物 -")]), _vm._v(" "), _c('div', {
    staticClass: "works-wrapper",
    staticStyle: {
      "padding": "20px 20px 70px 50px"
    }
  }, [_c('div', {
    staticClass: "work"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day3/你若安好便是晴天.jpg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("你若安好便是晴天")])]), _vm._v(" "), _c('div', {
    staticClass: "work"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day3/平易近人.jpg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("平易近人")])]), _vm._v(" "), _c('div', {
    staticClass: "work"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day3/万物和你一样动人.jpg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("万物和你一样动人")])]), _vm._v(" "), _c('div', {
    staticClass: "work"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day3/美洲小宇宙.jpg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("美洲小宇宙")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-wrapper",
    staticStyle: {
      "border-bottom": "0",
      "padding-top": "45px",
      "padding-right": "50px",
      "border-right": "1px solid #d9d9d9"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("- 女生小说 -")]), _vm._v(" "), _c('div', {
    staticClass: "works-wrapper"
  }, [_c('div', {
    staticClass: "work"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day3/半生缘.jpg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("半生缘")])]), _vm._v(" "), _c('div', {
    staticClass: "work"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day3/水云间.jpg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("水云间")])]), _vm._v(" "), _c('div', {
    staticClass: "work"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day3/一帘幽梦.jpg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("一帘幽梦")])]), _vm._v(" "), _c('div', {
    staticClass: "work"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day3/红玫瑰与白玫瑰.jpg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("红玫瑰与白玫瑰")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-wrapper",
    staticStyle: {
      "border-bottom": "0",
      "padding-top": "45px",
      "padding-left": "50px"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("- 经典文学 -")]), _vm._v(" "), _c('div', {
    staticClass: "works-wrapper"
  }, [_c('div', {
    staticClass: "work"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day3/呼啸山庄.jpg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("呼啸山庄")])]), _vm._v(" "), _c('div', {
    staticClass: "work"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day3/忏悔录.jpg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("忏悔录")])]), _vm._v(" "), _c('div', {
    staticClass: "work"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day3/沉思录.jpg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("沉思录")])]), _vm._v(" "), _c('div', {
    staticClass: "work"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day3/神曲.jpg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("神曲")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "separate-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "cooperator-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("- 众多合作商已倾情加盟 -")]), _vm._v(" "), _c('div', {
    staticClass: "cooperator-list"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/logo/logo-01.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/logo/logo-02.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/logo/logo-03.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/logo/logo-04.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/logo/logo-05.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/logo/logo-06.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/logo/logo-07.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/logo/logo-08.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "separate-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "more-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("- 了解更多 -")]), _vm._v(" "), _c('div', {
    staticClass: "links-wrapper"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'idols'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/others/大神云集@2x.png")
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'classic'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/others/经典汇聚@2x.png")
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'benefits'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/others/福利体系@2x.png")
    }
  })])], 1)]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-join-bottom",
    attrs: {
      "to": {
        name: 'anchorIndex'
      }
    }
  }, [_vm._v("立即加入")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-join-fixed",
    attrs: {
      "to": {
        name: 'anchorIndex'
      }
    }
  }, [_vm._v("立即加入")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-context"
  }, [_c('p', [_vm._v("大冰《好吗好的》、张爱玲《倾城之恋》、当年明月《明朝那些事儿》、琼瑶")]), _vm._v(" "), _c('p', [_vm._v("《水云间》……")]), _vm._v(" "), _c('p', [_vm._v("这些大热的作品，都在虚位以待，等你来演绎")]), _vm._v(" "), _c('p', [_vm._v("加入我们，用你独有的声音，为他们诠释出不一样的色彩")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "32px",
      "padding": "45px 0 60px"
    }
  }, [_vm._v("- 欢迎作品入驻 -")]), _vm._v(" "), _c('p', [_vm._v("如果您是拥有文字作品的作者或版权方")]), _vm._v(" "), _c('p', [_vm._v("希望将文字作品有声化")]), _vm._v(" "), _c('p', [_vm._v("随时欢迎加入平台")]), _vm._v(" "), _c('p', [_vm._v("这里将有众多主播给美丽的文字带上声音的翅膀")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cda0ff3c!./~/vue-loader/lib/selector.js?type=template&index=0!./views/popularize/WorkLib.vue
// module id = 1111
// module chunks = 0